import { render } from "./MechanicalUpgradeModal.vue?vue&type=template&id=684fc8ef&scoped=true"
import script from "./MechanicalUpgradeModal.vue?vue&type=script&lang=js"
export * from "./MechanicalUpgradeModal.vue?vue&type=script&lang=js"

import "./MechanicalUpgradeModal.vue?vue&type=style&index=0&id=684fc8ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684fc8ef"]])

export default __exports__